import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

export const styles = {
  LibraryUsageGridPanelContent: css`
    padding-bottom: 100px;
  `,

  LibraryOverviewIssuesColumn: css`
    font-size: 14px;
    width: 100%;
    margin-left: 35px;
    height: 380px;
  `,

  libraryOverviewCVELink: css`
    margin-left: 8px;
    font-size: 14px;
    font-weight: 400;
    color: #0da1a9;
    cursor: pointer;
    line-height: 18px;
  `,

  SourceList: css`
    width: 100%;
    margin-right: 205px;
    margin-top: -10px;
    margin-bottom: 25px;

    @media (min-width: 992px) {
      margin-right: 224px;
    }

    @media (min-width: 1900px) {
      margin-right: 255px;
    }

    @media (min-width: 2000px) {
      margin-right: 410px;
    }
  `,
  libraryOverviewCVEScore: (color: string) => css`
    margin-left: 10px;
    font-size: 20px;
    font-weight: bold;
    color: ${color};
  `,
  libraryOverviewInformationHeader: css`
    font-size: 18px;
    font-weight: 700;
    color: ${theme.color.black};
    font: Roboto;
    margin-bottom: 5px;
  `,
  libraryOverviewInformationBody: css`
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 24px;
    font: Lato;
  `,
  libraryOverviewRiskHeader: css`
    font-size: 18px;
    font-weight: 700;
    color: ${theme.color.black};
    font: Roboto;
    margin-bottom: 16px;
  `,
  libraryOverviewRiskBodyListItem: css`
    font-size: 14px;
    width: 100%;
    flex-direction: row;
    display: flex;
    align-items: center;
    height: 34px;
  `,
  libraryOverviewPolicyViolationHeader: css`
    font-size: 16px;
    font-weight: 700;
    color: ${theme.color.black};
  `,
  libraryOverviewPolicyList: css`
    font-size: 16px;
    line-height: 24px;
    margin-left: -20px;
    margin-bottom: 15px;
    margin-top: 5px;
  `
}
